import { Edge } from '../internal-types';

export const edges: Edge[] = ['top', 'right', 'bottom', 'left'];
